import React, { ChangeEvent, FC, useEffect, useState } from 'react';
import { Grid, Paper, styled, Tab, Tabs } from '@mui/material';
import { ActionButtons } from 'components';
import { useFindSlug } from 'dashboard409a/utilities';
import { ITheme } from 'theme/types';
import { INavigation } from './types';

const NavigationPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: (theme as unknown as ITheme).palette.primary['600'],
  overflowX: 'hidden',
}));

const Container = styled(Grid)(({ theme }) => ({
  margin: 0,
  padding: `0px ${theme.spacing(2)}`,
}));

const TabsContainer = styled(Grid)({
  padding: '0px !important',
});

const StyledTabs = styled(Tabs)({
  // Additional tabs styling can go here if needed
});

const StyledTab = styled(Tab)(({ theme }) => ({
  color: '#80A4C5',
  fontSize: '12px',
  fontWeight: 600,
  minWidth: 0,
  padding: `${theme.spacing(2)} ${theme.spacing(3)}`,

  '&:hover': {
    color: (theme as unknown as ITheme).palette.white,
  },

  '&.Mui-selected': {
    color: `${(theme as unknown as ITheme).palette.white} !important`,
  },
}));

const NavChildren = styled(Grid)({
  marginBottom: '12px',
  marginRight: '12px',
});

const Navigation: FC<INavigation> = props => {
  const { items } = props;

  const [selectedTab, setSelectedTab] = useState(0);

  const currentSlug = useFindSlug();

  useEffect(() => {
    const slugIndex = items.findIndex(item => item.id === currentSlug);

    setSelectedTab(slugIndex >= 0 ? slugIndex : 0);
  }, [currentSlug, items]);

  const handleChange = (_event: React.SyntheticEvent, selected: number) => {
    items[selected].handleAction();
    setSelectedTab(selected);
  };

  return (
    <NavigationPaper square elevation={0}>
      <Container container direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
        <TabsContainer item>
          <StyledTabs value={selectedTab} onChange={handleChange} indicatorColor="primary" scrollButtons="auto">
            {items.map((tabItem, tabIndex) => (
              <StyledTab disabled={tabItem?.disabled ?? false} key={`tab-${tabItem.id}`} label={tabItem.title} />
            ))}
          </StyledTabs>
        </TabsContainer>
        <NavChildren item>
          <ActionButtons />
        </NavChildren>
      </Container>
    </NavigationPaper>
  );
};

export default Navigation;
